/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2023, Bulb Inc.  For more information, please email contact@hellobulb.com.
 *
 *           _
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
 */
import Cookies from 'js-cookie';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

/**
 * our assignment http service which contains end points for server calls.
 */
@Injectable({
  providedIn: 'root',
})
export class AssignmentHttpService {

  /**
   * Default Constructor.
   * @param http Http client
   */
  constructor(private http: HttpClient) { }

  /**
   * list of assignment groups and folders.
   * @returns an observable that returns assignment folder.
   */
  getAssignmentFolders() {
    return this.http.get(
      'assignment/folders',
    ) as Observable<any>;
  }

  /**
   * submit assignment to accounts.
   * @param data contains params.
   * @param force contains boolean value to post assignment forcefully.
   * @param isAssignCollection whether assigning a collection.
   * @returns returns list of eligible and non-eligible accounts for assignment post.
   */
  assignmentGroups(data, force, isAssignCollection: boolean) {
    const url = isAssignCollection
      ? `assignment?force=${force}&collection=true`
      : `assignment?force=${force}`;

    return this.http.post(url, data) as Observable<any>;
  }

  /**
   * Delete assignment.
   * @param id Folder id.
   */
  deleteAssignment(id) {
    return this.http.delete(`assignment/folders/${id}`, {}) as Observable<any>;
  }
}
